<template>
    <div v-bind:style="{backgroundColor:getCourseSubColor(courseId)}">
        <HeaderNav v-if="!isWeixinBrowser()" :beforecolor="'#fff'" :backcolor="getCourseBuyButtonColor(courseId)"
                   @returnBack="goToBack"/>
        <div class="imgLazyLoadHead"><img v-bind:src="getheadImage()" alt=""/></div>
        <div class="lesson_introduce"><div @click="lessonIntroduceClick" v-bind:style="{color:getCourseWordColor(courseId)}">课程介绍 >></div></div>
        <WordsBeforeItem :lessonArray="obj240WordsHomeInfo.freeTrial"
                         :totalPartCount="totalPartCount.toString()"
                         :courseId="courseId.toString()"
                         :isFreeTrial="'1'" @lessonClick="freeLessonClick"/>
        <div class="all_lesson" :style="{color:getCourseWordColor(courseId)}">
            <div class="all_lesson_line" :style="{backgroundColor:getCourseWordColor(courseId), 'margin-right': '10px'}"></div>
            <div class="all_lesson_title">全部课程</div>
            <div class="all_lesson_line" :style="{backgroundColor:getCourseWordColor(courseId), 'margin-left': '10px'}"></div>
        </div>
        <div class="lesson_content">
            <WordsBeforeItem :lessonArray="obj240WordsHomeInfo.lessonArray"
                             :totalPartCount="totalPartCount.toString()"
                             :courseId="courseId.toString()" @lessonClick="lessonClick"/>
            <div class="lesson_list_bottom" :style="{'height': adapterMarginBottom()}"></div>
        </div>
        <div class="bottom_tool" :style="{height: adapterBigScreenHeight()}">
            <div class="tabbar_buy" :style="{'background-color':getCourseBuyButtonColor(courseId), 'margin-bottom': adapterBigScreen()}" @click="buyClick">
                <span>购买课程</span>
                <div class="go" :style="{color:getCourseBuyButtonColor(courseId)}">立即前往</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {MessageBox} from "mint-ui";

    export default {
        name: "wordsbefore",
        data() {
            return {
                courseId: parseInt(this.$route.query.courseId),
                obj240WordsHomeInfo: {},
                imgUrl: "",
                totalPartCount: 4,
            }
        },
        methods: {
            goToBack() {
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid;

                if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    if (that.isAppIos()) {
                        var vUrl = "readingclubapp:gobackMyCourse";
                        document.location = vUrl;
                    }

                    if (that.isAppAndroid()) {
                        window.note.gobackMyCourse();
                    }
                } else {
                    that.goBack(this.$router);
                }
            },
            getheadImage:function(){
                return require('@/assets/w' + this.courseId + '.jpg');
            },
            lessonIntroduceClick:function(){
                this.$router.push({name: 'pageView', query: {url: "https://www.xiaohuasheng.cn/mtesthome_"+ this.obj240WordsHomeInfo.articleId +"/come_1"}});
            },
            buyClick:function(){
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid;

                if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    if (that.isAppIos()) {
                        let vYouZanUrl = this.obj240WordsHomeInfo.buyUrl.replace(new RegExp('https:','g'), '');
                        let vUrl = "readingclubapp:buyWordsBefore:" + that.courseId + ":" + vYouZanUrl;
                        document.location = vUrl;
                    }

                    if (that.isAppAndroid()) {
                        window.note.buyWordsBefore(that.courseId, this.obj240WordsHomeInfo.buyUrl);
                    }
                } else {
                    that.$router.push({name: 'excessivebuy', query: {buyUrl: that.obj240WordsHomeInfo.buyUrl}});
                }
            },
            freeLessonClick: function (pk) {
                this.$router.push({
                    name: 'wordLesson',
                    query: {courseId: this.courseId, lessonId: pk}
                });
            },
            lessonClick: function (pk) {
                window.console.log(pk);

                MessageBox.confirm('', {
                    message: ' ',
                    title: '要先购买才能上课哦～快去购买吧！',
                    showConfirmButton:false,
                    showCancelButton:true,
                    closeOnClickModal: false,
                    cancelButtonClass:'cancelButton',
                    confirmButtonClass:'confirmButton',
                    cancelButtonText:'知道了'
                });
            },
            scrollToPositin(section) {
                document.getElementById('section_' + section).scrollIntoView();
            },
            adapterBigScreen: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return "0px";
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值

                return rate > limit ? "36px" : "0px";
            },
            adapterBigScreenHeight: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return "80px";
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值

                return rate > limit ? "86px" : "50px";
            },
            adapterMarginBottom: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return "80px";
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值

                return rate > limit ? "126px" : "90px";
            }
        },
        beforeCreate() {
            let that = this;
            let vCourseId = parseInt(that.$route.query.courseId);
            let isIos = that.isAppIos() ? 1 : 0;
            let url = "240words/homeInfo2/" + vCourseId + "/0/" + isIos;

            that.$axios.get(url).then((response) => {
                that.obj240WordsHomeInfo = response.data;
                that.imgUrl = this.$qiNiuDomainBase + that.obj240WordsHomeInfo.h5Picture;
                that.noShowGuideWordsAfter = that.getCount(that.obj240WordsHomeInfo.key1);
                that.courseId = vCourseId;
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        mounted() {
            window.BeforeScrollTop = 0;
        },
        beforeRouteLeave(to, from, next) {
            window.BeforeScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            next()
        },
        activated() {
            window.scrollTo(0, window.BeforeScrollTop);
        }
    }
</script>

<style scoped>
    .imgLazyLoadHead {
        position: relative;
        padding: 0px;
    }
    .imgLazyLoadHead img {
        width: 100%;
        margin: auto;
    }
    .lesson_introduce {
        text-align: center;
    }
    .lesson_introduce div {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        margin-top: 20px;
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: bold;
    }
    .clear {
        clear: both;
        line-height: 0;
        font-size: 0;
        height: 0;
        over-flow: hidden;
    }
    .lesson_list_bottom {
        height: 80px;
    }
    .tab_title {
        font-size: 15px;
        font-weight: bold;
    }
    .bottom_tool {
        position: fixed;
        background-color: #f4f4f4;
        width: 100%;
        z-index: 10000;
        bottom: 0;
        height: 50px;
    }
    .tabbar_buy {
        display: flex;
        height: 50px;
        background-color: #ff505a;
        width: 100%;
        z-index: 10000;
        align-items: center;
        justify-content: center;
    }
    .tabbar_buy span {
        color: white;
        font-size: 17px;
        text-align: center;

    }
    .tabbar_buy .go {
        position: absolute;
        height: 26px;
        line-height: 26px;
        right: 15px;
        background-color: white;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 13px;
        color: #ff505a;
        text-align: center;
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
    }

    .all_lesson {
        margin-top:15px;
        margin-bottom: 10px;
        text-align: center;
        font-size: 15px;
    }
    .all_lesson {
        margin-top:40px;
        text-align: center;
    }
    .all_lesson .all_lesson_line {
        width: 56px;
        height: 1px;
        display: inline-block;
        vertical-align: middle;
    }
    .all_lesson .all_lesson_title {
        font-size: 15px;
        display: inline-block;
    }
</style>
